<div class="tw-flex-auto">
  @if (!isLoading) {
    <div class="tw-mb-4">
      <campaign-badge [status]="campaign?.campaignStatus"></campaign-badge>
      @if (campaign?.coInvestmentStatus) {
        <div
          class="tw-mt-2 tw-rounded-md tw-border-l-4 tw-border-l-warning tw-bg-warning-light tw-p-3"
        >
          <div
            class="tw-mt-1 tw-whitespace-pre-line tw-break-words tw-text-xs !tw-text-warning-dark"
          >
            {{ campaign.coInvestmentStatus }}
          </div>
        </div>
      }
    </div>
    <ul class="tw-mb-0 tw-list-none tw-space-y-4 tw-pl-0" id="campaignStats">
      @for (item of stats; track item) {
        @if (!item.show || item.show(campaign)) {
          <li>
            <!-- Number -->
            <div class="p-text-h3 tw-text-black">
              @if (item.isCurrency) {
                <span>
                  {{ item.value | numberSuffix: { isSuffix: false, numberFormat: '1.0-1' } }}
                </span>
              } @else {
                <span>{{ item.value }}</span>
                <!-- Add tooltip to show ended date -->
                @if (item.name == 'campaign.leftToGo') {
                  <button
                    type="button"
                    class="btn-transparent tw-align-middle"
                    [ngbPopover]="fundingPeriodTooltip"
                    container=".tooltip-container"
                    triggers="click"
                  >
                    <div class="pitchin-icon pitchin-icon-help-circle p-help-icon--lg"></div>
                  </button>
                  <ng-template #fundingPeriodTooltip>
                    <div class="tooltip-container tw-max-w-[200px] md:tw-max-w-[250px]">
                      <div class="tw-font-bold tw-text-black">
                        {{ 'campaign.fundingPeriod' | translate }}
                      </div>
                      {{ campaign.startAt | amDateFormat: 'D MMM YYYY' }} -
                      {{ campaign.endAt | amDateFormat: 'D MMM YYYY' }}
                    </div>
                  </ng-template>
                }
              }
            </div>
            <!-- Progress bar -->
            @if (item.name == 'campaign.currentRaisedAmount') {
              <div class="p-text-tag">
                {{ Math.floor(campaign.raisedPercentage) }}%
                {{ 'campaign.ofTheMinTarget' | translate }} ({{
                  campaign.minimumTargetAmount
                    | numberSuffix: { isSuffix: false, numberFormat: '1.0-1' }
                }})
              </div>
              <mat-progress-bar
                aria-label="progressbar"
                mode="determinate"
                height="10"
                class="tw-mt-1.5"
                [color]="campaign.raisedPercentage >= 100 ? 'success' : ''"
                [value]="campaign.raisedPercentage"
              >
              </mat-progress-bar>
            } @else {
              <div class="p-text-tag">{{ item.name | translate }}</div>
            }
            <!-- Label -->
          </li>
        }
      }
    </ul>
    <!-- View Summary link -->
    @if (campaign?.isSummaryPagePublished) {
      <div class="tw-mt-6">
        <a
          class="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2 tw-rounded tw-px-4 tw-py-2.5 tw-text-sm tw-font-semibold tw-uppercase tw-tracking-wider tw-no-underline hover:tw-opacity-90"
          style="color: #2d898b; background-color: #d5f2f0"
          [routerLink]="['/campaign-summary', campaign?.slug]"
          (click)="onViewSummary()"
        >
          {{ 'campaignSummary.viewSummaryPage' | translate }}
          <i class="fa fa-arrow-right tw-text-xs"></i>
        </a>
      </div>
    }
    @if (
      campaign?.campaignStatus !== CampaignStatus.Live &&
      campaign?.campaignStatus !== CampaignStatus.Cooling
    ) {
      <hr class="tw-my-6" />
    }
    @if (campaign?.campaignStatus == CampaignStatus.PreLive) {
      <div
        class="p-text-body"
        [innerHTML]="
          'campaign.preliveFooterNote' | translate: { campaignName: campaign?.company?.brandName }
        "
      ></div>
    }
    @if ([CampaignStatus.Success].includes(campaign?.campaignStatus)) {
      <p class="p-text-body !tw-text-secondary-light">
        {{ 'campaign.successfulFooterNote' | translate }}
        {{ campaign.endAt | amDateFormat: 'D MMM YYYY' }}.
      </p>
    }
    @if ([CampaignStatus.ShareAllotment].includes(campaign?.campaignStatus)) {
      <p class="p-text-body !tw-text-secondary-light">
        {{ 'campaign.successfulFooterNote' | translate }}
        {{ campaign.endAt | amDateFormat: 'D MMM YYYY' }}.
      </p>
    }
    @if (
      campaign?.campaignStatus == CampaignStatus.Fail ||
      campaign?.campaignStatus == CampaignStatus.Rejected
    ) {
      <p class="p-text-body">{{ 'campaign.failedFooterNote' | translate }}.</p>
    }
  } @else {
    <app-skeleton [width]="'80%'" [marginBottom]="2.5"></app-skeleton>
    <app-skeleton></app-skeleton>
    <app-skeleton></app-skeleton>
  }
</div>

<!-- Normal cta button on top -->
<div class="tw-mt-10">
  @if (
    campaign?.isPrivate &&
    !campaign?.isInvited &&
    !isIssuer &&
    [CampaignStatus.PreLive, CampaignStatus.Live].includes(campaign?.campaignStatus)
  ) {
    <p class="p-text-body tw-text-center !tw-text-xs tw-text-body tw-text-opacity-80">
      <span class="tw-mb-0.5 tw-block" [innerHTML]="'common.inviteOnlyBlurp' | translate"></span>
      @if (campaign?.registrationLinkUrl) {
        <a
          [href]="campaign?.registrationLinkUrl"
          target="_blank"
          class="p-link-secondary p-link-underline tw-text-base tw-font-bold"
        >
          {{ 'common.registerInterest' | translate }}
        </a>
      }
    </p>
  }

  <ng-container *ngTemplateOutlet="ctaBtn"></ng-container>
</div>

<!-- Sticky footer cta -->
<div class="sticky-cta" #footerCta>
  <div class="container-fluid cta-footer-wrapper">
    <ng-container *ngTemplateOutlet="ctaBtn"></ng-container>
  </div>
</div>

<ng-template #ctaBtn>
  @if (
    daysLeft > 0 &&
    (!campaign?.isPrivate || (campaign?.isPrivate && campaign?.isInvited) || isIssuer)
  ) {
    <span
      class="cta-footer-countdown tw-hidden tw-font-bold tw-lowercase tw-text-body tw-text-opacity-70"
    >
      {{ daysLeftLabel }} {{ 'campaign.leftToInvest' | translate }}
    </span>
  }
  @if (
    campaign?.isPrivate &&
    !campaign?.isInvited &&
    !isIssuer &&
    [CampaignStatus.PreLive, CampaignStatus.Live].includes(campaign?.campaignStatus)
  ) {
    <span class="cta-footer-countdown tw-hidden !tw-text-xs">
      <span [innerHTML]="'common.inviteOnlyBlurp' | translate" class="lg:tw-pr-2"></span>
      @if (campaign?.registrationLinkUrl) {
        <a
          [href]="campaign?.registrationLinkUrl"
          target="_blank"
          class="p-link-secondary p-link-underline tw-font-bold lg:tw-text-base"
        >
          {{ 'common.registerInterest' | translate }}
        </a>
      }
    </span>
  }
  @if (
    [CampaignStatus.PreLive, CampaignStatus.Live, CampaignStatus.Cooling].includes(
      campaign?.campaignStatus
    )
  ) {
    <agmo-button
      [loading]="isInvestNowLoading"
      [disabled]="isCtaDisabled"
      [buttonClass]="'btn-green tw-w-full md:tw-w-72 font-size-regular tw-break-words tw-whitespace-normal'"
      [buttonLabel]="getCtaLabel()"
      [buttonIcon]="!isCtaDisabled ? null : 'lock'"
      (click)="handleInvestNow()"
    >
    </agmo-button>
  }
</ng-template>
